const MobileAdProfiles = {
  dynamicFooterAdPopup: {
    name: 'dynamic-footer-ad-popup',
    path: '/1018855/mobile_newsarticle_bottom_320x100',
    size: [
      [320, 100],
      [1, 1]
    ]
  },
  reutersTop: {
    // 最上方廣告(第一屏 banner)
    name: 'mobile-index-top-tw-stock',
    path: '/1018855/mobile_twstock_320*100_1',
    size: [[320, 100]]
  },
  detailUnderShare100: {
    /* 績效表現下方,相關新聞上方 */
    name: 'detailUnderShare100',
    path: '/1018855/cnyes_mobile_news_article_320x100_undershare',
    size: [[300, 250]]
  },
  reutersBottom: {
    // 最下方
    name: 'mobile-index-bottom-tw-stock',
    path: '/1018855/mobile_twstock_320*100_2',
    size: [[320, 100]]
  },
  relatedNews: {
    /* 相關新聞第三則廣告 */
    name: 'mobile_news_category_list_native_1',
    path: '/1018855/mobile_news_category_list_native_1',
    size: [['fluid']]
  },
  relatedNews2: {
    /* 相關新聞第三則廣告(彈出式卡片) */
    name: 'mobile_news_category_list_native_2',
    path: '/1018855/mobile_news_category_list_native_2',
    size: [['fluid']]
  }
};

export default MobileAdProfiles;
